import React from 'react';

interface ReportSectionHeadingProps {
  number: number;
  title: string;
  className?: string;
}

const ReportSectionHeading: React.FC<ReportSectionHeadingProps> = ({ number, title, className }) => {
  return (
    <div className={className}>
      <div className="flex items-center gap-3">
        <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary text-[11px] font-bold text-primary-foreground">
          {number}
        </span>
        <h2 className="font-jakarta text-[15px] font-bold tracking-[-0.01em] text-foreground">{title}</h2>
      </div>
    </div>
  );
};

export default ReportSectionHeading;
